var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Checkbox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.5%",
    y: "-2.5%",
    width: "105.0%",
    height: "110.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101960784   0 0 0 0 0.160784314   0 0 0 0 0.215686275  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.19073199,1.05697242 C9.02400699,0.949872423 8.80260699,0.998247423 8.69595699,1.16452242 L4.39913199,7.84927242 C4.30575699,7.99417242 4.18313199,8.07922242 4.05398199,8.08822242 C3.92370699,8.09632242 3.79208199,8.02994742 3.67935699,7.89832242 L1.12988199,4.92427242 C1.00140699,4.77464742 0.775281987,4.75687242 0.624981987,4.88557242 C0.474906987,5.01404742 0.457581987,5.24039742 0.586056987,5.39047242 L3.13553199,8.36474742 C3.37785699,8.64689742 3.70073199,8.80507242 4.03170699,8.80507242 C4.05555699,8.80507242 4.07918199,8.80439742 4.10303199,8.80237242 C4.45853199,8.77784742 4.78568199,8.57152242 5.00145699,8.23604742 L9.29805699,1.55197242 C9.40538199,1.38547242 9.35700699,1.16407242 9.19073199,1.05697242 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Square"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FF1F9D",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#472A87",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Checkmark"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Colour",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelected);
export default __webpack_public_path__ + "static/media/checkbox-selected.509dcd92362c5a2af6476b4907f8d4c3.svg";
export { ForwardRef as ReactComponent };